import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';
import { Menu as SemanticUIMenu } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../services/proptypes';
var defaultProps = {
  children: null,
  className: ''
};

/**
 * This can be used to group items. For instance,
 * <Menu position="right">
 *    <Link {...someProps} />
 *    <Link {...someOtherProps} />
 *    <Link {...thirdProps} />
 * </Menu>
 */
function Menu(_ref) {
  var children = _ref.children,
    className = _ref.className,
    menuProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SemanticUIMenu.Menu, _extends({
    className: "site-navigation-menu ".concat(className)
  }, menuProps), children);
}
Menu.defaultProps = defaultProps;
export default Menu;